import React from "react";
import { useModal } from "../../_context/ModalContext";

const Login = () => {
    const { openModal } = useModal();
    return (
        <>
            <section>
                <div className="inn-body-section">
                    <div className="container">

                        <div className="row">
                            <div className="col-sm-8 offset-sm-2">
                                <section className="d-flex align-items-center justify-content-center pt-5 pb-5 bg-light">
                                    <div className="text-center">
                                        <h1 className="mb-4">Welcome to Younic Home</h1>
                                        <p className="mb-5 text-muted">Please log in or create a new account to continue</p>
                                        <div className="d-flex justify-content-center gap-3">
                                            <button
                                                onClick={() => openModal('login')}
                                                className="btn btn-primary btn-lg px-4 mr-3"
                                            >
                                                Login
                                            </button>
                                            <button
                                                onClick={() => openModal('register')}
                                                className="btn btn-outline-primary btn-lg px-4"
                                            >
                                                Register
                                            </button>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Login;
